__turbopack_context__.v({
  "environmental-dummy-icon-container": "EmailSignatureEnvironmentalFooter-module-scss-module__2YR9RW__environmental-dummy-icon-container",
  "interactive-environmental-footer": "EmailSignatureEnvironmentalFooter-module-scss-module__2YR9RW__interactive-environmental-footer",
});
